import { BUSINESS_NAME, BUSINESS_MAP_URL } from "@/lib/seo";

export interface GoogleReview {
  id: string;
  author: string;
  rating: number;
  text: string;
  publishedAt: string;
}

// Snapshot verified against the public listing; not a live Google API feed.
export const googleReviewSummary = {
  businessName: BUSINESS_NAME,
  rating: 5,
  reviewCount: 65,
  verifiedAt: "2026-10-03",
  sourceUrl: BUSINESS_MAP_URL,
} as const;

// Original text, public author and five-star rating verified on the same listing.
export const googleReviews: GoogleReview[] = [
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT2pkTmVtaE1ZMlJtVkdSbFNWa3pWM1JLZUVablRIYxAB",
    author: "youyou lafhali",
    rating: 5,
    text: "J’ai beaucoup apprécié le service. La seule compagnie qui ont pris le temps de bien diagnostiquer. Merci beaucoup",
    publishedAt: "2026-08-01",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT21KRWFUTnlOM3BLU0VSalkzUm5iM0UyT1VOZmFWRRAB",
    author: "Cheikh Konde",
    rating: 5,
    text: "J’ai beaucoup aimé le service. Rapide, professionnel et le tarif a été respecté. Merci!",
    publishedAt: "2026-06-11",
  },
  {
    id: "Ci9DQUlRQUNvZENodHljRjlvT2tkYVVTMWtkR0YwWWtvNVZIZHJkVTR3Y21WaWRHYxAB",
    author: "Ana sofia Alves cabral",
    rating: 5,
    text: "Très bon service, travail propre et professionnel. Le plombier était sympathique, ponctuel et compétent. Je recommande fortement.",
    publishedAt: "2026-06-01",
  },
];